import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useUser } from "../Commonfunction/UserContext";
import { getData } from "../Commonfunction/CommonFunction";
import CommonModal from "../common/CommonModal";
import CutOffDateForm from "../Forms/CutOffDateForm";
import CenteredLoading from "../common/CenteredLoading";
import FormHeading from "../common/FormHeading";
import FinancialYearForm from "../Forms/FinancialYearForm";
import CommonCard from "../common/CommonCard";
import "../../assets/style/Dashboard.css";

const Dashboard = ({ apiUrl, titleName }) => {
  const userType = localStorage.getItem("user_type");
  const { id, employeeId } = useParams();
  const { userAccess, setUserAccess } = useUser();
  const navigate = useNavigate();
  
  const [cpadata, setCpaData] = useState(null);
  const [empList, setEmpList] = useState(null);
  const [empId, setEmpId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showCutoffModal, setCutoffModal] = useState(false);
  const [empBasedCoustomer, setEmpBasedCoustomer] = useState();
  
  const handleClose = () => {
    setShowModal(false);
  };

  const cutoffHandleClose = () => {
    setCutoffModal(false);
  };

  const CpaDataApi = async () => {
    setLoading(true);
    try {
      const api = apiUrl
        ? `${apiUrl}/${employeeId ? `${id}/${employeeId}` : id}`
        : id
        ? "/api/all-employees"
        : userType == "CPA"
        ? "/api/all-employees"
        : "/api/all-cpc";
      const result = await getData(api);
      if (result.success) {
        setCpaData(result?.data);
      } else {
        console.error(result?.message);
      }
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      setLoading(false);
    }
  };

  const empApi = async (api, id) => {
    setLoading(true);
    try {
      const result = await getData(api);
      if (result.success) {
        setEmpList(result.data);
        setEmpId();
      } else {
        console.error(result.message);
      }
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchDataUserAccess = async () => {
    try {
      const result = await getData("/api/user-access");
      if (result.success) {
        setUserAccess(result);
        if (result?.financial_year === true) {
          setShowModal(true);
        } else if (result?.financial_year_cutoff_date === true) {
          setCutoffModal(true);
        }
      }
    } catch (error) {
      console.log("Error:", error);
    }
  };

  const groupedData = cpadata?.reduce((acc, employee) => {
    const { employee_type_name } = employee;

    if (!acc[employee_type_name]) {
      acc[employee_type_name] = [];
    }

    acc[employee_type_name].push(employee);
    return acc;
  }, {});

  useEffect(() => {
    setCpaData([]);
    CpaDataApi();
    userType === "Employee" && fetchData();
  }, [titleName, userType, id, employeeId]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const api = "/api/all-customers";
      const result = await getData(api);
      if (result.success) {
        setEmpBasedCoustomer(result.data?.length);
      } else {
        console.error(result?.message);
      }
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDataUserAccess();
  }, []);

  // Function to assign color classes randomly but consistently
  const getColorClass = (index) => {
    const colors = ['blue', 'purple', 'green', 'orange', 'red'];
    return colors[index % colors.length];
  };

  return (
    <div className="dashboard">
      <div className="dashboard__container">
        {userType === "Employee" ? (
          <>
            {loading ? (
              <div className="dashboard__loading">
                <CenteredLoading />
              </div>
            ) : (
              <div className="dashboard__content">
                <div className="dashboard__grid">
                  {empBasedCoustomer && (
                    <div
                      className="dashboard__card-wrapper"
                      onClick={() => navigate("/Client")}
                      style={{ "--index": 0 }}
                    >
                      <CommonCard
                        item={"Customers"}
                        groupeDataEmploye={empBasedCoustomer}
                        groupedDataFlag={false}
                      />
                    </div>
                  )}
                </div>
              </div>
            )}
          </>
        ) : (
          <>
            <div className="dashboard__header">
              <FormHeading
                heading={userType === "CPA" ? "All Employees" : titleName}
                isHideBtn={
                  titleName === "All Employees" && userType !== "CPA"
                    ? false
                    : true
                }
                path="/"
              />
            </div>

            {userType !== "CPA" ? (
              <div className="dashboard__content">
                <div className="dashboard__grid">
                  {loading ? (
                    <div className="dashboard__loading">
                      <CenteredLoading />
                    </div>
                  ) : empList && empList.length > 0 ? (
                    empList.map((item, index) => (
                      <div
                        className={`dashboard__card-wrapper modern-card--${getColorClass(index)}`}
                        key={item.key}
                        style={{ "--index": index }}
                        onClick={() => {
                          const targetPath =
                            titleName === "All Employees" &&
                            userType !== "CPA"
                              ? `/${id}/${item.id}`
                              : `/${item.id}`;
                          navigate(targetPath);
                        }}
                      >
                        <CommonCard item={item} />
                      </div>
                    ))
                  ) : cpadata && cpadata.length > 0 ? (
                    cpadata.map((item, index) => (
                      <div
                        className={`dashboard__card-wrapper modern-card--${getColorClass(index)}`}
                        key={item.key}
                        style={{ "--index": index }}
                        onClick={() => {
                          const targetPath =
                            titleName === "All Employees" &&
                            userType !== "CPA"
                              ? `/${id}/${item.id}`
                              : `/${item.id}`;
                          navigate(targetPath);
                        }}
                      >
                        <CommonCard item={item} />
                      </div>
                    ))
                  ) : (
                    <div className="dashboard__empty">
                      <p>No data available</p>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div className="dashboard__content">
                <div className="dashboard__grid">
                  {loading ? (
                    <div className="dashboard__loading">
                      <CenteredLoading />
                    </div>
                  ) : cpadata?.length > 0 ? (
                    <>
                      {Object.keys(groupedData).map((group, index) => (
                        <div
                          className={`dashboard__card-wrapper modern-card--${getColorClass(index)}`}
                          key={index}
                          style={{ "--index": index }}
                          onClick={() => {
                            navigate("/employees", {
                              state: {
                                filterName: group,
                              },
                            });
                          }}
                        >
                          <CommonCard
                            item={group}
                            groupedData={groupedData}
                          />
                        </div>
                      ))}
                    </>
                  ) : (
                    <div className="dashboard__empty">
                      <p>No data available</p>
                    </div>
                  )}
                </div>
              </div>
            )}

            {(userType === "CPA" && showModal) && (
              <CommonModal
                isOpen={showModal}
                onClose={handleClose}
                title={"Add Financial Year"}
                size="large"
                dashboardView="dashboardView"
              >
                <FinancialYearForm
                  onClose={handleClose}
                  setCutoffModal={setCutoffModal}
                  fetchDataUserAccess={fetchDataUserAccess}
                />
              </CommonModal>
            )}

            {(userType === "CPA" && showCutoffModal) && (
              <CommonModal
                isOpen={showCutoffModal}
                onClose={cutoffHandleClose}
                title={"Add cutoff date"}
                size="large"
                dashboardView="dashboardView"
              >
                <CutOffDateForm
                  onClose={cutoffHandleClose}
                  fetchDataUserAccess={fetchDataUserAccess}
                />
              </CommonModal>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Dashboard;